import dayjs from "dayjs";
import { MessageElement } from "components/new/Chat/Message/Message";
import { DoctorMSStateInsurance } from "lib/graphql/megaSchema";
import { insuredInMap } from "lib/tools/insuredInMap";

export const getMedicalLeaveContent = (
  leave?: MessageElement["leave"] | MessageElement["careleave"],
) => {
  if (!leave) {
    return <span>Ładowanie...</span>;
  }

  const isMedicalLeave = (
    leave: Record<string, unknown> | null | undefined,
  ): leave is MessageElement["leave"] => {
    if (!leave) {
      return false;
    }

    return "leaveType" in leave;
  };

  const formatNip = (nip: string) => {
    const match = nip.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (!match) return nip;
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
  };

  const isGuardianDataAvailable = leave.leaves && leave.leaves[0].guardian;
  const isStayAddressDataAvailable = leave.leaves && leave.leaves[0].address;

  return (
    <span>
      e-Zwolnienie zostało wystawione poprawnie.
      <br />
      <br />
      {leave.leaves && isGuardianDataAvailable && (
        <>
          <b>Opiekun</b>
          <br />
          {leave.leaves[0].guardian?.firstName}{" "}
          {leave.leaves[0].guardian?.lastName}
          {"\n"}
          PESEL: {leave.leaves[0].guardian?.pesel}
          <br />
          <br />
        </>
      )}
      <b>Czas trwania zwolnienia</b>
      <br />
      {isMedicalLeave(leave)
        ? dayjs(leave.inabilitySince).format("D MMM")
        : dayjs(leave.careSince).format("D MMM")}{" "}
      -{" "}
      {isMedicalLeave(leave)
        ? dayjs(leave.inabilityUntil).format("D MMM YYYY")
        : dayjs(leave.careUntil).format("D MMM YYYY")}
      <br />
      <br />
      <b>Ubezpieczony w</b>
      <br />
      {leave.insuredIn
        ? insuredInMap[leave.insuredIn as DoctorMSStateInsurance]
        : leave.insuredIn}
      <br />
      <br />
      <b>Pracodawcy</b>
      {leave.payers && leave.payers.length && (
        <ol className="flex flex-col gap-2">
          {leave.payers.map((payer) => {
            return (
              <div key={payer.id} className="flex flex-col">
                <span>
                  {payer.name}{" "}
                  {payer.doNotSendPayerInfo ? "- Nie przekazuj ZLA" : ""}
                </span>
                <span>NIP: {formatNip(payer.nip)}</span>
              </div>
            );
          })}
        </ol>
      )}
      <br />
      <b>Rozpoznanie główne</b>
      <br />
      {leave.icd10Main.icd10} {leave.icd10Main.name}
      <br />
      <br />
      {isMedicalLeave(leave) && (
        <>
          <b>Zalecenia</b>
          <br />
          {leave.recommendation === "canWalk"
            ? "Może chodzić"
            : "Powinien leżeć"}
          <br />
          <br />
        </>
      )}
      {isMedicalLeave(leave) &&
        leave.codes &&
        Object.entries(leave.codes).filter(([k, v]) => v && k !== "__typename")
          .length > 0 && (
          <>
            <b>Kod literowy</b>
            <br />
            <div style={{ display: "flex", gap: "6px" }}>
              {Object.entries(leave.codes)
                .filter(([k, v]) => v && k !== "__typename")
                .map(([k], i, arr) => (
                  <span key={k}>
                    {k}
                    {i < arr.length - 1 ? "," : ""}
                  </span>
                ))}
            </div>
            <br />
          </>
        )}
      {leave.leaves && isStayAddressDataAvailable && (
        <div className="flex flex-col">
          <b>Adres pobytu</b>
          <span>
            {leave.leaves[0].address?.street}{" "}
            {leave.leaves[0].address?.houseNumber}
            {leave.leaves[0].address?.flatNumber
              ? `/${leave.leaves[0].address?.flatNumber}`
              : ""}
          </span>
          <span>
            {leave.leaves[0].address?.zipCode} {leave.leaves[0].address?.city}
          </span>
        </div>
      )}
    </span>
  );
};
